import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dayHoursConverter'
})
export class DayHoursConverterPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(value: string | number): string {
    if (value == null || value === '') {
      return '';
    }

    const hours = Number(value);
    if (isNaN(hours)) {
      return '';
    }

    const dayLabel = this.translate.instant('day');
    const hourLabel = this.translate.instant('hour');
    const andLabel = this.translate.instant('login.term.and.privacy.policy.3');

    if (hours < 24) {
      return `${hours} ${hourLabel}`;
    }

    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;

    if (remainingHours === 0) {
      return `${days} ${dayLabel}`;
    }

    return `${days} ${dayLabel} ${andLabel} ${remainingHours} ${hourLabel}`;
  }
}
